import { Vue, Component } from 'vue-property-decorator'
import VtBubble from '@/components/common/VtBubble.vue'
import CommonSampleStatusBadge from '@/components/common/CommonSampleStatusBadge.vue'

@Component({
    components: {
        VtBubble,
        CommonSampleStatusBadge
    }
})

export default class GrossingTouchSampleViewHeader extends Vue {
}
